interface ProgressBarWheelIconProps {
  readonly progress: number // percentage from 0 to 100
  readonly dark?: boolean // optional dark mode prop
}

export function ProgressBarWheelIcon({
  progress = 0,
  dark = false
}: Readonly<ProgressBarWheelIconProps>) {
  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(100, Math.max(0, progress))

  // Calculate the arc path for the progress
  const radius = 9 // Slightly smaller than the outer circle to fit inside

  // Calculate start position (top of circle, -90 degrees)
  const startAngle = -90
  const x = 12 + radius * Math.cos((startAngle * Math.PI) / 180)
  const y = 12 + radius * Math.sin((startAngle * Math.PI) / 180)

  // Create the arc path
  const arcPath = `
    M ${x} ${y}
    A ${radius} ${radius} 0 ${normalizedProgress > 50 ? 1 : 0} 1 
    ${12 +
      radius *
        Math.cos(
          ((startAngle + (normalizedProgress * 360) / 100) * Math.PI) / 180
        )}
    ${12 +
      radius *
        Math.sin(
          ((startAngle + (normalizedProgress * 360) / 100) * Math.PI) / 180
        )}
  `

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      {/* Background circle */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="#6E6877"
        strokeWidth="2"
        fill="none"
      />
      {/* Progress arc */}
      <path
        d={arcPath}
        stroke={dark ? '#FFFFFF' : '#0E031D'}
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
      {/* White center circle */}
      <circle cx="12" cy="12" r="3" fill={dark ? '#FFFFFF' : '#0E031D'} />
    </svg>
  )
}
